// /currencies/rub.json
import axios from 'axios'

const ExchangeRateHttpClient = axios.create({
    baseURL: 'https://cdn.jsdelivr.net/npm/@fawazahmed0/currency-api@latest/v1/',
    timeout: 5000,
})
ExchangeRateHttpClient.interceptors.request.use(
    config => {
        return config
    },
    err => Promise.reject(err),
)
ExchangeRateHttpClient.interceptors.response.use(
    async res => res.data,
    err => Promise.reject(err),
)

export default ExchangeRateHttpClient
